import React, { useState, useEffect } from "react";
import { GeoMessagePanel } from "./geo-message.styled";
import { getGeoCountry } from "../../utils/apiRequests";

const GeoMessage = () => {
  const euCountries = [
    "BE",
    "BG",
    "CZ",
    "DK",
    "DE",
    "EE",
    "IE",
    "EL",
    "ES",
    "FR",
    "HR",
    "IT",
    "CY",
    "LV",
    "LT",
    "LU",
    "HU",
    "MT",
    "NL",
    "AT",
    "PL",
    "PT",
    "RO",
    "SI",
    "SK",
    "FI",
    "SE",
  ];
  const turkey = "TR";
  const unitedKingdom = "UK";
  let msgHtml;
  const [geoCountry, setGeoCountry] = useState<string | undefined>();

  useEffect(() => {
    getGeoCountry()
      .then((res) => {
        setGeoCountry(res.country);
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  switch (geoCountry) {
    case euCountries.filter((euCountry) => euCountry === geoCountry)[0]: // Return matched EU country
      msgHtml = (
        <>
          Are you in Europe? Switch to our{" "}
          <a href="https://xometry.eu/">European website</a>.
        </>
      );
      break;
    case turkey:
      msgHtml = (
        <>
          Are you in Türkiye? Switch to our{" "}
          <a href="https://xometry.com.tr/">Turkish website</a>.
        </>
      );
      break;
    case unitedKingdom:
      msgHtml = (
        <>
          Are you in the UK? Switch to our{" "}
          <a href="https://xometry.uk/">UK website</a>.
        </>
      );
      break;
  }

  return (
    (geoCountry && msgHtml && (
      <GeoMessagePanel kind="warning">{msgHtml}</GeoMessagePanel>
    )) || <></>
  );
};

export default GeoMessage;
